module.exports = __webpack_public_path__ + "static/TNM079___Modeling_And_Animation__Lab_3-91db00dd5d088490efa9d1d67dad91cd.pdf";